import React, { useEffect, useState } from "react";
import axios from "axios";

export default function StatusPage() {
  const [tapId, setTapId] = useState(null);
  const [status, setStatus] = useState(null);
  const [errorData, setErrorData] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tapIdFromUrl = searchParams.get("tap_id");

    if (tapIdFromUrl) {
      setTapId(tapIdFromUrl);
      axios
        .post("https://tp-api.alsendi.me/status", { id: tapIdFromUrl })
        .then((res) => setStatus(res.data["chargeData"]["status"]==="CAPTURED"?"SUCCESS":res.data["chargeData"]["status"]))
        .catch((err) => {
          console.error(err);
          setErrorData(err);
        });
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Payment Status</h1>
        <h4>Developed By Ali AlSendi</h4>
      </header>
      <main className="App-main">
      <div className="card-container">

        {tapId && (
          <div className="result success">
            <h3>Tap ID Found:</h3>
            <p>{tapId}</p>
          </div>
        )}
        {status && (
          <div className="result success">
            <h3>Status:</h3>
            <p>{status}</p>
          </div>
        )}
        {errorData && (
          <div className="result error">
            <h3>Error fetching status</h3>
          </div>
        )}
                </div>

      </main>
    </div>
  );
}